import { OrganismosListCtxProvider } from "./OrganismosListCtx";
import { OrganismosListPageSection } from "./OrganismosListPageSection";

export function OrganismosListPage()
{
  return (
<OrganismosListCtxProvider>
  <OrganismosListPageSection/>
</OrganismosListCtxProvider>
  )
}
